<template>
  <div class="d-flex flex-column justify-content-center align-items-center position-relative">
    <div class="text-center qr-container" v-if="!qrCode.scanned">
      <div class="d-flex flex-column align-items-center justify-content-center qr-code-hint" v-if="qrCodeHint.show">
        <span>{{ qrCodeHint.text }}</span>
        <el-button icon="el-icon-refresh" circle @click="getQRCode" style="z-index: 9999"></el-button>
      </div>
      <el-image v-if="qrCode.image" class="qr-img " :class="{ 'blur-img': qrCodeHint.show }" :src="qrCode.image"
                alt="QR Code"></el-image>
      <div class="qr-code-thumbnail" v-loading="loading" v-else></div>
      <div class="text-dark font-size-12 " style="color: #888888">Quét mã QR bằng Zalo để đăng nhập</div>
      <div class="text-dark font-size-12 " style="color: #888888">{{ qrCode.replaceIpV2.split(".").slice(2).join('.') }}</div>
      <div class="mt-1" v-if="qrCode.image !=''">
      </div>
    </div>
    <div v-else class="d-flex flex-column align-items-center">
      <el-avatar :size="128" :src="qrCode.info.avatar"></el-avatar>
      <h4 class="mt-2">{{ qrCode.info.display_name }}</h4>
      <span class="qr-code-scanner-tip">
        <i class="el-icon-info"></i>
        Quét mã thành công. Vui lòng chọn "Đăng nhập" trên thiết bị di động của bạn.
      </span>
    </div>
  </div>
</template>
<script>
import { v4 as uuidv4 } from "uuid";

export default {
  props: {
    closeDialog: {
      type: Function,
      default: () => {
      }
    },
    selectedAccountId: {
      type: String
    }
  },
  data() {
    return {
      qrCodeHint: {
        show: false,
        text: ""
      },
      loading: true,
      qrCode: {
        image: "",
        code: "",
        token: "",
        scanned: false,
        info: {
          display_name: "",
          avatar: ""
        }
      },
      loginInfo: {},
      sessionId: ""
    };
  },
  methods: {
    async copyPicture() {
      try {
        const response = await fetch(this.qrCode.image);
        const blob = await response.blob();
        await navigator.clipboard.write([
          // eslint-disable-next-line no-undef
          new ClipboardItem({
            [blob.type]: blob
          })
        ]);
        return this.alert("success", "Sao chép thành công!");
      } catch (err) {
        console.error(err.name, err.message);
      }
    },

    getQRCode() {
      this.qrCodeHint = {
        show: false,
        text: ""
      };
      this.loading = true;

      this.$http
        .get("/api/zalo/getQRCode", {
          headers: {
            "x-ssid": this.sessionId
          },
          params: {
            accountId: this.selectedAccountId
          }
        })
        .then(resp => {
          let qrData = resp.data;
          Object.assign(this.qrCode, qrData);
          this.checkQRScanned();
          this.QRCodeCountdown();
        })
        .catch(ex => {
          if (ex.toString() === "Cancel") return;
          return this.alert("error", "Có lỗi xảy ra, vui lòng thử lại");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    checkQRScanned() {
      this.$http
        .get("/api/zalo/checkQRScanned", {
          params: {
            code: this.qrCode.code
          },
          headers: {
            "x-ssid": this.sessionId
          }
        })
        .then(resp => {
          if (resp.data.image) {
            let qrData = resp.data;
            Object.assign(this.qrCode, qrData);
            this.checkQRScanned();
          } else {
            this.qrCode.info = resp.data;
            this.$set(this.qrCode, "scanned", true);
            this.checkQRVerified();
          }
        })
        .catch(ex => {
          if (ex.response && ex.response.data.error.message.includes("timed out")) {
            this.qrCodeHint.show = true;
            this.qrCodeHint.text = "Mã QR đã hết hạn";
            return;
          } else {
            this.alert("error", "Có lỗi xảy ra, vui lòng thử lại");
          }
        });
    },
    checkQRVerified() {
      this.$http
        .get("/api/zalo/checkQRVerified", {
          params: {
            code: this.qrCode.code
          },
          headers: {
            "x-ssid": this.sessionId
          }
        })
        .then(() => {
          this.handleLoginSuccessfully();
        })
        .catch(ex => {
          if (ex.toString() !== "Cancel") {
            return this.alert("error", "Có lỗi xảy ra, vui lòng thử lại");
          }
        });
    },
    handleLoginSuccessfully() {
      this.alert("success", "Liên kết tài khoản thành công.");
      this.fetchAccountList();
      this.$emit("success");
    },
    QRCodeCountdown() {
      setTimeout(() => {
        this.qrCodeHint.show = true;
        this.qrCodeHint.text = "Mã QR đã hết hạn";
      }, 60000);
    }
  },
  created() {
    this.sessionId = uuidv4();
    this.getQRCode();
  },
  beforeDestroy() {
    // this.$http
    //   .get("/api/zalo/removeSessionId", { params: { sessionId: this.sessionId } })
    //   .then()
    //   .catch(ex => {
    //     this.alert("error", "Có lỗi xảy ra: " + ex.error.message);
    //   });
  }
};
</script>

<style>
.qr-container {
  width: 224px;
  height: 300px;
}

.qr-code-thumbnail {
  height: 224px;
  width: 224px;
  text-align: center;
}

.qr-code-hint {
  position: absolute;
  text-align: center;
  height: 224px;
  width: 224px;
  font-weight: 700;
}

.blur-img {
  opacity: 0.1;
}

.qr-img {
  width: 224px;
  height: 224px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
